import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { CreateReturnInvoiceViewModel } from "../createReturnInvoice/createReturnInvoice-viewModel";
import  { InvoicesListView } from "./invoicesList-view"
import { DebitCardSelectorViewModel } from "src/Sell/Payment/debitPayment/debitCardSelector-viewModel";
import { Converters } from "src/converters";
import { DebitTransferPaymentViewModel } from "./debitTransferPayment/debitTransferPayment-viewModel";

export class InvoicesListViewModel extends WindowViewModel implements IPopup{
    public getTitle(): string {
        return "لیست فاکتورهای خرید";
    }
    constructor(parentViewModel: ViewModel,refresh?:boolean) {
        super(parentViewModel);
        if(refresh==null)
            refresh = true;
        this.isForMasoomi = false;
        this.invoices = ObservableArray.create<Invoice>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation));
        if(refresh==true)
            this.refresh();

    }
    GetDefaultView(): View <ViewModel> {
        return new InvoicesListView();
    }
    public getTypeId(): string {
        return "VM-4DE82D1E-7643-4E2C-9B6D-B9F0F2EA5880"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set invoices(v: ObservableArray<Invoice>) { this._invoices = v; } public get invoices(): ObservableArray<Invoice> { return this._invoices;} private _invoices: ObservableArray<Invoice>;
    public set isForMasoomi(v: boolean) { this._isForMasoomi = v; } public get isForMasoomi(): boolean { return this._isForMasoomi;} private _isForMasoomi: boolean;
    
    closePopup(resultCode: string) {    }
    
    refresh() {
        this.loader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            if(filteringInformation.OrderInfo.length == 0)
            {
                let sort = {
                    fieldName:'time',
                    order:'DESC',
                    type:'date'
                };
                filteringInformation.OrderInfo = [sort];
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PurchaseServices/GetAllPurchaseInvoices',{
                FurtherQueryInfo:filteringInformation,
                Masoomi : this.isForMasoomi
            });
            this.invoices.update(...result.Invoices.map((x,i)=>{
                let r = new Invoice(this);
                r.index = i+1;
                r.factorNo=x.FactorNo;
                r.parentFactorNo=x.ParentFactorNo;
                r.id=x.Id;
                r.isReturn=!x.IsNormal;
                r.operatorPersonnelCode=x.PersonnelCode;
                r.operatorName=x.PersonnelName;
                r.sellerCode=x.SellerCode;
                r.sellerName=x.SellerName;
                r.warehouseName = x.WarehouseName;
                r.time= moment.utc(x.Time);
                r.total=x.Total;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async showInvoice(invoice: Invoice) {
        let selectedInvoice = new DetailedInvoice(this);
        selectedInvoice.loadByInvoiceId(invoice.id)
        this.showPopup(selectedInvoice);
    }
}

export class Invoice extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:InvoicesListViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent : InvoicesListViewModel;

    public set factorNo(v: string) { this._factorNo = v; } public get factorNo(): string { return this._factorNo;} private _factorNo: string;
    public set parentFactorNo(v: string) { this._parentFactorNo = v; } public get parentFactorNo(): string { return this._parentFactorNo;} private _parentFactorNo: string;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set isReturn(v: boolean) { this._isReturn = v; } public get isReturn(): boolean { return this._isReturn;} private _isReturn: boolean;
    public set operatorPersonnelCode(v: string) { this._operatorPersonnelCode = v; } public get operatorPersonnelCode(): string { return this._operatorPersonnelCode;} private _operatorPersonnelCode: string;
    public set operatorName(v: string) { this._operatorName = v; } public get operatorName(): string { return this._operatorName;} private _operatorName: string;
    public set sellerCode(v: string) { this._sellerCode = v; } public get sellerCode(): string { return this._sellerCode;} private _sellerCode: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName;} private _sellerName: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set total(v: number) { this._total = v; } public get total(): number { return this._total;} private _total: number;
        
    edit() {
        this._typedParent.showInvoice(this);
    }

    addPayment(){
        let popup = new DebitTransferPaymentViewModel(this);
        popup.invoiceId = this.id;
        popup.amount = this.total;
        this.requestShowingPopup(popup);
    }
}

export class DetailedInvoice extends ViewModel implements IPopup{
    
    public getTypeId(): string {return 'detailedInvoice';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:InvoicesListViewModel) {
        super(parent);
        this._typedParent = parent;
        this.lineItems = ObservableArray.create<LineItem>();
        this.payments = ObservableArray.create<Payment>();
    }
    closePopup() {}
    private _typedParent : InvoicesListViewModel;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName;} private _sellerName: string;
    public set sellerCode(v: string) { this._sellerCode = v; } public get sellerCode(): string { return this._sellerCode;} private _sellerCode: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    public set personnelCode(v: string) { this._personnelCode = v; } public get personnelCode(): string { return this._personnelCode;} private _personnelCode: string;
    
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set additions(v: number) { this._additions = v; } public get additions(): number { return this._additions;} private _additions: number;
    public set deficits(v: number) { this._deficits = v; } public get deficits(): number { return this._deficits;} private _deficits: number;
    public set total(v: number) { this._total = v; } public get total(): number { return this._total;} private _total: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice;} private _finalPrice: number;
    public set dollarPrice(v: number) { this._dollarPrice = v; } public get dollarPrice(): number { return this._dollarPrice;} private _dollarPrice: number;
    
    public set factorNo(v: string) { this._factorNo = v; } public get factorNo(): string { return this._factorNo;} private _factorNo: string;
    public set parentFactorNo(v: string) { this._parentFactorNo = v; } public get parentFactorNo(): string { return this._parentFactorNo;} private _parentFactorNo: string;
    public set lineItems(v: ObservableArray<LineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<LineItem> { return this._lineItems;} private _lineItems: ObservableArray<LineItem>;
    public set payments(v: ObservableArray<Payment>) { this._payments = v; } public get payments(): ObservableArray<Payment> { return this._payments;} private _payments: ObservableArray<Payment>;
    
    public set canShowReturn(v: boolean) { this._canShowReturn = v; } public get canShowReturn(): boolean { return this._canShowReturn;} private _canShowReturn: boolean;
    public set canShowSend(v: boolean) { this._canShowSend = v; } public get canShowSend(): boolean { return this._canShowSend;} private _canShowSend: boolean;
    
    returnFactor(){
        var send = new CreateReturnInvoiceViewModel(this._typedParent, this.id);
        this._typedParent.showPopup(send);

    }

    async recieve(){
        try {
            let confirm = await this.messageBoxWarningYesNo('فاکتور دریافت شود؟','دریافت فاکتور');
            if (confirm == 'no') {
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PurchaseServices/ReceivePurchaseInvoiceInWarehouse',{
                PurchaseFactorId:this.id,
                LineItemInfo:this.lineItems.map(x=>{
                    return {
                        LineItemId:x.id,
                        WarehouseDescription:x.warehouseDescription
                    };
                })
            });
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess('فاکتور با موفقیت دریافت شد','دریافت فاکتور');
                this.closePopup();
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }    
    
    async loadByInvoiceId(id: string) {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PurchaseServices/GetPurchaseFactorDetail',{
                Id:id
            });
            this.id = id;
            this.sellerName = result.SellerName;
            this.sellerCode = result.SellerCode;
            this.personnelName = result.PersonnelName;
            this.personnelCode= result.PersonnelCode;
            this.warehouseName = result.WarehouseName;
            this.time = moment.utc(result.Time);
            this.additions = result.Additions;
            this.deficits = result.Deficits;
            this.total = result.Total;
            this.finalPrice = result.FinalPrice;
            this.dollarPrice = result.DollarPrice;
            this.factorNo = result.FactorNo;
            this.parentFactorNo = result.ParentFactorNo;
            this.canShowReturn = !result.IsReturnInvoice && result.UserHasAccessToReturn && result.IsWarehouseBillCreated && !result.ImportedInvoice;
            this.canShowSend = !result.IsReturnInvoice && !result.HasReturnInvoice && !result.IsWarehouseBillCreated && !result.ImportedInvoice;
            this.lineItems.update(...result.LineItems.map((x,i)=>{
                let lineItem = new LineItem(this);
                lineItem.index = i+1;
                lineItem.productCarModel = x.ProductCarModel;
                lineItem.productName = x.ProductName;
                lineItem.productCode = x.ProductCode;
                lineItem.measuredProductId = x.MeasuredProductId;
                lineItem.id = x.LineItemId;
                lineItem.unitName = x.UnitName;
                lineItem.amount = x.Amount;
                lineItem.fee = x.Fee;
                lineItem.additions = x.Additions;
                lineItem.deficits = x.Deficits;
                lineItem.total = x.Total;
                lineItem.finalPrice = x.FinalPrice;
                lineItem.location = x.Locations;
                lineItem.canShowSend = this.canShowSend;
                return lineItem;
            }));
            this.payments.update(...result.Payments.map(x=>{
                let payment = new Payment(this);
                payment.time = x.Time;
                payment.amount = x.Amount;
                payment.typeNo = x.TypeNo;
                payment.typeName = x.TypeName;
                payment.status = x.Status;
                payment.methodName = x.MethodName;
                payment.methodNo = x.MethodNo;
                payment.type = x.Type;
                return payment;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }   
    }
}

export class LineItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set measuredProductId(v: number) { this._measuredProductId = v; } public get measuredProductId(): number { return this._measuredProductId;} private _measuredProductId: number;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName;} private _unitName: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set fee(v: number) { this._fee = v; } public get fee(): number { return this._fee;} private _fee: number;
    public set additions(v: number) { this._additions = v; } public get additions(): number { return this._additions;} private _additions: number;
    public set deficits(v: number) { this._deficits = v; } public get deficits(): number { return this._deficits;} private _deficits: number;
    public set total(v: number) { this._total = v; } public get total(): number { return this._total;} private _total: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice;} private _finalPrice: number;
    public set location(v: string) { this._location = v; } public get location(): string { return this._location;} private _location: string;
    public set warehouseDescription(v: string) { this._warehouseDescription = v; } public get warehouseDescription(): string { return this._warehouseDescription;} private _warehouseDescription: string;
    public set canShowSend(v: boolean) { this._canShowSend = v; } public get canShowSend(): boolean { return this._canShowSend;} private _canShowSend: boolean;
    
}

export class Payment extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set typeNo(v: number) { this._typeNo = v; } public get typeNo(): number { return this._typeNo;} private _typeNo: number;
    public set typeName(v: string) { this._typeName = v; } public get typeName(): string { return this._typeName;} private _typeName: string;
    public set status(v: string) { this._status = v; } public get status(): string { return this._status;} private _status: string;
    public set methodName(v: string) { this._methodName = v; } public get methodName(): string { return this._methodName;} private _methodName: string;
    public set methodNo(v: number) { this._methodNo = v; } public get methodNo(): number { return this._methodNo;} private _methodNo: number;
    public set type(v: number) { this._type = v; } public get type(): number { return this._type;} private _type: number;  
}

export class masoomiInvoiceList extends InvoicesListViewModel{
    public getTitle(): string {
        return "لیست فاکتورهای خرید - معصومی";
    }

    constructor(parent:ViewModel) {
        super(parent,false);
        this.isForMasoomi = true;
        this.refresh();
    }
    
    
}